export const getUserData=()=>{
   return JSON.parse(localStorage.getItem("data") as any)?.user || null;
}

export const getToken=()=>{
    return JSON.parse(localStorage.getItem("data") as any)?.token || null;
}

export const getRefreshToken=()=>{
    return JSON.parse(localStorage.getItem("data") as any)?.refreshToken || null;
}

export const getRoleData=()=>{
    return JSON.parse(localStorage.getItem("data") as any)?.role || null;
}
    
export const getMenuData=()=>{
    return JSON.parse(localStorage.getItem("data") as any)?.user?.menus || []
}

export const formatUdiosCode=(number:number|string)=>{
  const num= number?.toString();
  return number? 'XXXXXXX'+num?.slice(-4) : "NA" ;
}

